"use strict";
/**
 * @file Created on Fri Aug 24 2018
 * @author VBr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes number's in range of a slider
 */


var RangeSliderValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(RangeSliderValidator, _Validator_1$Validato);

  function RangeSliderValidator(min, max) {
    var _this;

    _classCallCheck(this, RangeSliderValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeSliderValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.min = min;
    _this.max = max;
    return _this;
  }

  _createClass(RangeSliderValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      var _this2 = this;

      if (value.some(function (val) {
        return val < _this2.min;
      })) {
        return new ValidationResult_1.ValidationError(RangeSliderValidator.UNDER_MIN_LENGTH_ERROR, this.min);
      }

      if (value.some(function (val) {
        return val > _this2.max;
      })) {
        return new ValidationResult_1.ValidationError(RangeSliderValidator.OVER_MAX_LENGTH_ERROR, this.max);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return RangeSliderValidator;
}(Validator_1.Validator);

exports.RangeSliderValidator = RangeSliderValidator;
RangeSliderValidator.UNDER_MIN_LENGTH_ERROR = 'UNDER_MIN_LENGTH';
RangeSliderValidator.OVER_MAX_LENGTH_ERROR = 'OVER_MAX_LENGTH';